
import Vue from 'vue'

export default ({ fromDate, toDate }) =>
  Vue.$http.get('reports/udn_report/', {
    params: {
      fromDate,
      toDate,
    }
  }).then(response => response.data)


// WEBPACK FOOTER //
// ./src/services/reports/fetchUDNReport.js